import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import LoadScript from '../components/load-script';
import SlateViewer from '../viewer/slate-viewer';
import { SlateDiff } from '../utils/diff';
import { renderNode, renderLeaf } from '../containers/render-utils/viewer-utils';
import '../assets/css/diff-viewer.css';
var DiffViewer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DiffViewer, _React$PureComponent);
  var _super = _createSuper(DiffViewer);
  function DiffViewer(_props) {
    var _this;
    _classCallCheck(this, DiffViewer);
    _this = _super.call(this, _props);
    _this.renderDiffNode = function (props) {
      var element = props.element;
      var data = element.data ? element.data : {};
      var diffState = data['diff_state'];
      var nodeDepth = data['node_depth'];
      if (diffState === 'diff-added') {
        if (nodeDepth > 1) {
          if (element.type === 'blockquote' || element.type === 'code_block') {
            return /*#__PURE__*/React.createElement("div", {
              className: 'diff-added-container'
            }, renderNode(props));
          }
          return renderNode(props);
        } else {
          return /*#__PURE__*/React.createElement("div", {
            className: 'diff-added'
          }, renderNode(props));
        }
      } else if (diffState === 'diff-removed') {
        if (nodeDepth > 1) {
          if (element.type === 'blockquote' || element.type === 'code_block') {
            return /*#__PURE__*/React.createElement("div", {
              className: 'diff-removed-container'
            }, renderNode(props));
          }
          return renderNode(props);
        } else {
          return /*#__PURE__*/React.createElement("div", {
            className: 'diff-removed'
          }, renderNode(props));
        }
      } else if (diffState === 'diff-replaced') {
        if (nodeDepth > 1) {
          return renderNode(props);
        } else {
          return /*#__PURE__*/React.createElement("div", {
            className: 'diff-replaced'
          }, renderNode(props));
        }
      } else {
        return renderNode(props);
      }
    };
    _this.value = [];
    _this.slateDiff = new SlateDiff();
    return _this;
  }
  _createClass(DiffViewer, [{
    key: "render",
    value: function render() {
      var newMarkdownContent = this.props.newMarkdownContent;
      var oldMarkdownContent = this.props.oldMarkdownContent;
      this.value = this.slateDiff.getDiffDocument(newMarkdownContent, oldMarkdownContent);
      return /*#__PURE__*/React.createElement(LoadScript, {
        scriptSource: this.props.scriptSource
      }, /*#__PURE__*/React.createElement(SlateViewer, {
        style: {
          width: '100%'
        },
        renderDiffElement: this.renderDiffNode,
        renderDiffLeaf: renderLeaf,
        value: this.value
      }));
    }
  }]);
  return DiffViewer;
}(React.PureComponent);
export default DiffViewer;